import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-203b4f84"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["type", "disabled", "tabindex"]
const _hoisted_2 = {
  key: 0,
  class: "button__spinner",
  "data-ts": "btn-spinner"
}

import { computed } from 'vue';

type ButtonVariant = 'primary' | 'secondary' | 'negative' | 'filter' | 'textOnly';


export default /*#__PURE__*/_defineComponent({
  __name: 'Btn',
  props: {
    variant: {},
    label: {},
    disabled: { type: Boolean },
    isLoading: { type: Boolean },
    iconRight: { type: Boolean },
    iconName: {},
    size: {},
    buttonType: {}
  },
  emits: ["click"],
  setup(__props: any) {



const props = __props;

const getButtonClass = computed(() => {
	switch (props.variant) {
		case 'secondary':
			return 'button--secondary';
		case 'negative':
			return 'button--negative';
		case 'filter':
			return 'button--filter';
		case 'textOnly':
			return 'button--text-only';
		case 'primary':
		default:
			return 'button--primary';
	}
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass([
			'button',
			{ 'button--small': _ctx.size === 'small' },
			{ 'button--loading': _ctx.isLoading },
			getButtonClass.value,
		]),
    type: _ctx.buttonType || 'button',
    disabled: _ctx.disabled,
    tabindex: _ctx.isLoading ? -1 : 0,
    "data-ts": "btn",
    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('click', $event)), ["prevent"]))
  }, [
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2))
      : _createCommentVNode("", true),
    (_ctx.iconName && !_ctx.iconRight && !_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("span", {
          key: 1,
          class: _normalizeClass([`bx ${_ctx.iconName} mr-2`, { 'text-lg': _ctx.size !== 'small' }]),
          "data-ts": "btn-icon-left"
        }, null, 2))
      : _createCommentVNode("", true),
    _createTextVNode(" " + _toDisplayString(_ctx.label) + " ", 1),
    (_ctx.iconName && _ctx.iconRight && !_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("span", {
          key: 2,
          class: _normalizeClass([`bx ${_ctx.iconName} ml-2`, { 'text-lg': _ctx.size !== 'small' }]),
          "data-ts": "btn-icon-right"
        }, null, 2))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}
}

})